export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryWireless/theme/components/scorecard/MetricsLabels/index.js